export default {
    // Main
    title: 'Zielprognose',
    maintainTitle: 'Gewichtserhaltung',

    // States
    noData: 'Schließe ein paar Tage deines Plans ab und protokolliere dein Gewicht, um deine Zielprognose zu sehen.',
    calculate: 'Jetzt berechnen',
    calculating: 'Berechne...',
    updating: 'Aktualisiere...',

    // Labels
    start: 'Start',
    current: 'Aktuell',
    currentWeight: 'Aktuelles Gewicht',
    target: 'Ziel',
    targetWeight: 'Zielgewicht',
    goal: 'Ziel',
    goalLabel: 'ZIEL',
    you: 'DU',
    complete: 'Abgeschlossen',

    // Goal-specific
    lossRate: 'Abnahmerate',
    gainRate: 'Zunahmerate',
    pace: 'Tempo',
    week: 'Woche',
    toGo: 'noch',
    toGain: 'zuzunehmen',

    // Projected date
    projectedDate: 'Voraussichtliches Zieldatum',
    days: 'Tage',
    weeks: 'Wochen',

    // Stats
    confidence: 'Zuverlässigkeit',
    logs: 'Einträge',

    // Status
    ahead: 'Vor dem Zeitplan',
    onTrack: 'Im Plan',
    behind: 'Leicht hinterher',
    stalled: 'Fortschritt gestoppt',
    insufficientData: 'Daten sammeln',

    // Maintain
    maintainingWell: 'Gut erhalten',
    adjustNeeded: 'Leichte Anpassung nötig',
    maintainInfo: 'Über Gewichtserhaltung',
    maintainInfoDesc: 'Erhaltung bedeutet, dein Gewicht innerhalb eines gesunden Bereichs stabil zu halten. Kleine Schwankungen sind normal!',
    maintainTolerance: 'Toleranzbereich',
    maintainToleranceDesc: 'Innerhalb von ±1 kg deines Zielgewichts zu bleiben gilt als ausgezeichnete Erhaltung.',
    maintainSuccessMsg: 'Du hältst dein Gewicht perfekt. Mach weiter so!',
    maintainAboveMsg: 'Du bist etwas über deinem Ziel. Erwäge, die Kalorien etwas zu reduzieren.',
    maintainBelowMsg: 'Du bist etwas unter deinem Ziel. Erwäge, die Kalorien etwas zu erhöhen.',
    maintenanceRange: 'Erhaltungsbereich',
    variance: 'Abweichung',
    ideal: 'ideal',

    // Messages
    stalledMessage: 'Dein Fortschritt stockt. Erwäge, deine Kalorienaufnahme oder dein Aktivitätsniveau anzupassen.',
    behindMessage: 'Du bist etwas hinter dem Zeitplan. Bleib konsequent und du kommst wieder auf Kurs!',

    // Info modal
    howItWorks: 'Wie funktioniert die Zielprognose',
    infoTheoryTitle: 'Dein Ernährungsplan (Theorie)',
    infoTheoryDesc: 'Erwartete Gewichtsveränderung durch dein aktuelles Kalorien',
    infoTheoryDescDeficit: 'defizit',
    infoTheoryDescSurplus: 'überschuss',
    infoRealityTitle: 'Dein tatsächlicher Fortschritt (Realität)',
    infoRealityDesc: 'Dein echter Gewichtstrend der letzten Wochen.',
    infoBlendingTitle: 'Intelligente Mischung',
    infoBlendingEarly: 'Anfangs',
    infoBlendingLater: 'Später',
    moreTheory: 'Mehr Theorie',
    moreReality: 'Mehr Realität',
    infoStabilityTitle: 'Stabilitätsschutz',
    infoStabilityDesc: 'Dein Datum springt nicht durch tägliche Schwankungen herum. Nur konsequente Trends verschieben die Prognose.',
    infoImportantTitle: 'Wichtig',
    infoImportantDesc: 'Dies ist eine Prognose, keine Garantie. Setze deinen Plan fort, um auf Kurs zu bleiben!',

    // Goal reached
    goalReachedTitle: 'Ziel erreicht!',
    congratulations: 'Herzlichen Glückwunsch!',
    goalReachedMessage: 'Du hast dein Zielgewicht erfolgreich erreicht. Fantastische Arbeit!',
    startWeight: 'Startgewicht',
    totalLost: 'Insgesamt verloren',
    totalGained: 'Insgesamt zugenommen',
    daysOnPlan: 'Tage im Plan',
    whatsNext: 'Wie geht es weiter?',
    nextStepsMessage: 'Erwäge ein neues Ziel zu setzen oder in den Erhaltungsmodus zu wechseln, um deine Ergebnisse zu halten.',
};